export class SignatureUtil {
  static HMAC_SHA256_ALGORITHM = 'sha256'
  static SIGNATURE_DELIMITER = ':'
  static PARAM_DELIMITER = '&'
  static NESTED_DELIMITER = '.'

  // 【主签名方法】生成 API 请求签名。
  static genSignature(packageName, deviceId, apiPath, timestamp, nonce, appSecret, businessParams) {
    if (!appSecret || appSecret === '' || !timestamp || !nonce) {
      throw new Error('参数错误')
    }

    // prettier-ignore
    try {
      // 1. 统一处理并排序所有业务参数，生成 sorted_params 字符串
      const sortedParamsStr = this.sortAndJoinParams(businessParams)

      // 2. 拼接最终的原始签名数据 (Data)
      const data =
        packageName +
        this.SIGNATURE_DELIMITER +
        deviceId +
        this.SIGNATURE_DELIMITER +
        apiPath +
        this.SIGNATURE_DELIMITER +
        timestamp +
        this.SIGNATURE_DELIMITER +
        nonce +
        this.SIGNATURE_DELIMITER +
        sortedParamsStr +
        this.SIGNATURE_DELIMITER +
        appSecret

      // 3. 计算 HMAC-SHA256 签名
      console.log('genSignature ~ data:', data)
      return this.calculateHmacSha256(data, appSecret)
    }
    catch (e) {
      throw new Error('签名生成失败: ' + e.message)
    }
  }

  // 负责将嵌套的 Map 扁平化，然后进行 ASCII 排序，最后拼接。
  // params 包含嵌套结构的参数 Map。
  // 拼接后的字符串，例如: page=1&sort=asc&user.id=123
  static sortAndJoinParams(params) {
    if (!params || Object.keys(params).length === 0) {
      return ''
    }

    const flatParams = {}
    this.flattenJsonMap(params, '', flatParams)
    const sortedKeys = Object.keys(flatParams).sort()

    return sortedKeys.map((key) => `${key}=${flatParams[key]}`).join(this.PARAM_DELIMITER)
  }

  // nestedMap 待扁平化的嵌套 (当前层)
  // rootKey   当前层的前缀键名
  // flatMap   扁平化结果
  static flattenJsonMap(nestedMap, rootKey, flatMap) {
    // 对键进行排序（TreeMap的等效实现）
    const sortedKeys = Object.keys(nestedMap).sort()

    for (const key of sortedKeys) {
      const value = nestedMap[key]
      const newKey = !rootKey ? key : rootKey + this.NESTED_DELIMITER + key

      if (value !== null && value !== undefined) {
        const tempType = Object.prototype.toString.call(value)
        // object
        // prettier-ignore
        if (tempType === '[object Object]') {
          this.flattenJsonMap(value, newKey, flatMap)
        }
        // array
        else if (tempType === '[object Array]') {
          flatMap[newKey] = `[${value.join(', ')}]`
        }
        // 基本类型
        else {
          flatMap[newKey] = String(value)
        }
      }
    }
  }

  // HMAC-SHA256 签名。
  static calculateHmacSha256(data, key) {
    const hash = CryptoJS.HmacSHA256(data, key)
    return CryptoJS.enc.Base64.stringify(hash)
  }
}

// 示例
// POST请求
// const businessParams = {
//   z: "My New Post",
//   a: "tech",
//   b: "article content...",
//   d: userMap // 嵌套 Map
// };

// GET请求
// const businessParams = {
//   d: "99",     // 路径参数
//   c: 1,        // 查询参数 (数字类型)
//   a: "desc"    // 查询参数
// };

// const signature = SignatureUtil.genSignature(packageName, deviceId, apiPath, timestamp, nonce, appSecret, businessParams);
